let url = "";
let appUrl = "";
let docApiUrl = "";

if (process.env.REACT_APP_STAGE === "local") {
    url = "http://localhost:5200";
    appUrl = "http://localhost:3000";
} else if (process.env.REACT_APP_STAGE === "dev") {
    url = "https://api-dev.oliverai.com.br";
    appUrl = "https://app-dev.oliverai.com.br";
    docApiUrl = "https://oliverai-sandbox.readme.io";
} else {
    url = "https://api.oliverai.com.br";
    appUrl = "https://app.oliverai.com.br";
    docApiUrl = "https://oliverai.readme.io";
}

export const Constants = {
    url,
    baseUrl: url + "/api/web",
    appUrl,
    docApiUrl,
};
